import {ViewStream, DomElement} from 'spyne';
import BlogArticleTmpl from './templates/page-blog-frontend.tmpl.html';
export class PageBlogArticleView extends ViewStream {

    constructor(props={}) {
        props.class = 'blog-article';
        props.template = BlogArticleTmpl;
      //props.template = "<h1>TeST</h1>";
      props.channels = [["CHANNEL_ROUTE", true], 'CHANNEL_UI'];

      super(props);
    }

    addActionListeners() {
        // return nexted array(s)
        return [
          ["CHANNEL_UI_CLICK_EVENT", "onBlogAnchorLinkCLicked", '.blog-anchor-link'],
          ["CHANNEL_ROUTE_CHANGE_EVENT", "disposeViewStream"]

        ];
    }

    broadcastEvents() {
        // return nexted array(s)
        return [
            ['a:not(.external)', 'click']
        ];
    }

  onBlogAnchorLinkCLicked(e){
      const {url} = e.payload;

      const toastEl$ = this.props.el$("#copy-toast");


    // Helper to show toast
    const showToast = () => {
      //console.log("TOAST EL ",toastEl$);

      if (toastEl$.exists === false){
        return;
      }

      let toast = toastEl$.el;



      toast.classList.add('visible');
      // Clear any existing timer to prevent flickering if clicked rapidly
      clearTimeout(toast.timer);
      toast.timer = setTimeout(() => {
        toast.classList.remove('visible');
      }, 2000); // Hide after 2 seconds
    };

     navigator.clipboard.writeText(url).then(() => {
      // Optional: Show a "Copied!" toast here
       showToast();
      //console.log('Link copied:', url);
    });
  }


  addAnchorLinks() {
    // Select all headers inside the blog article that have IDs
    const headers = this.props.el$('article.blog h2[id], article.blog h3[id]').arr;
    //console.log("headers", headers);
    headers.forEach(header => {
      // Create the anchor link element

      let toastEl$ = this.props.el$('#copy-toast');
      if (toastEl$.exists === false) {

        const toastEl = new DomElement({
          id: "copy-toast",
          data: "copied",
          class: "copy-notification"
        })

        this.props.el.appendChild(toastEl.render());

       // toast = document.createElement('div');
       //toast.id = 'copy-toast';
       // toast.className = 'copy-notification';
        //toast.textContent = 'Link copied to clipboard';
       // document.body.appendChild(toast);
      }




      const link = document.createElement('a');
      link.className = 'anchor-link blog-anchor-link';
      link.href = `#${header.id}`;
      link.textContent = '#'; // Or use an SVG icon here
      link.title = 'Link to this section';
      link.dataset.eventPreventDefault = true;
      const url = window.location.origin + window.location.pathname + '#' + header.id;
      link.dataset.url = url;

      //console.log("LINK IS ",link);

      // Optional: Click copies to clipboard instead of just jumping
/*      link.addEventListener('click', (e) => {
        e.preventDefault();
        const url = window.location.origin + window.location.pathname + '#' + header.id;

        // Update browser URL without reloading
        history.pushState(null, null, url);

        // Copy to clipboard
        navigator.clipboard.writeText(url).then(() => {
          // Optional: Show a "Copied!" toast here
          console.log('Link copied:', url);
        });

        // Trigger your existing scroll function manually if needed
        // scrollToHash();
      });*/

      // Prepend the link to the header
      header.prepend(link);
    });
  }


  scrollToHash() {
    // 1. Get the hash from the URL (e.g., "#my-section")
    const hash = window.location.hash;

    // 2. Check if hash exists and isn't just an empty "#"
    if (hash && hash.length > 1) {
      try {
        // 3. Remove the '#' and decode the string (handles special chars like spaces/%20)
        const id = decodeURIComponent(hash.substring(1));

        // 4. Find the element by ID
        //const element = document.getElementById(id);
        const el$ = this.props.el$(`#${id}`);


        if (el$.exists) {
          // 5. Scroll into view with smooth animation

          const element = el$.el;
          const offset = 96;

          // 2. Get the element's distance from the top of the viewport
          const elementPosition = element.getBoundingClientRect().top;

          // 3. Get the current scroll position
          const offsetPosition = elementPosition + window.scrollY - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        /*  el$.el.scrollIntoView({
            behavior: 'smooth',
            block: 'start' // Aligns the element to the top of the viewport
          });*/
        }
      } catch (e) {
        console.warn("Could not scroll to hash:", e);
      }
    }
  }


    onRendered() {
      this.addAnchorLinks();
      window.setTimeout(this.scrollToHash.bind(this),300);
    }

}

